import styled from "@emotion/styled";
import {
  controlFontSize,
  fontWeight,
  spacing,
  text,
} from "@atlas-int/tokens";
import { TradeDirection } from "@atlas-int/data/types";
import { UIView, worldGroupDatum } from "@atlas-int/data";
import { computeExporterImporterSwap } from "@atlas-int/controls";
import { useBaseExploreParams } from "../../visualization/paramSchemas";

interface Props {
  targetOption: TradeDirection;
  selected: boolean;
}

const TradeDirectionListItem = styled.li`
  margin: 0px ${spacing[1]} 0px 0px;
  padding: 0px;
  font-size: ${controlFontSize.sm};
  color: ${text.muted};

  &.selected {
    color: ${text.primary};
    font-weight: ${fontWeight.bold};
  }
`;

export default function TradeDirectionSelectorButton({
  targetOption,
  selected,
}: Props) {
  let buttonLabel: string | undefined;
  const [{ view, exporter, importer, tradeDirection }, setQuery] = useBaseExploreParams();

  if (targetOption === TradeDirection.Exports) {
    buttonLabel = "Exporter";
  } else if (targetOption === TradeDirection.Imports) {
    buttonLabel = "Importer";
  }

  const handleClick = () => {
    if (view === UIView.Markets && tradeDirection !== targetOption) {
      // Use the unified swap logic so edge cases (both-World, both-non-World)
      // are handled consistently.
      const result = computeExporterImporterSwap({
        importer,
        exporter,
        tradeDirection,
        view: "markets",
        worldGroupId: worldGroupDatum.groupId,
      });
      setQuery(result as { exporter: string; importer: string; tradeDirection: TradeDirection });
    } else {
      setQuery({
        tradeDirection: targetOption,
      });
    }
  };

  return (
    <TradeDirectionListItem
      className={selected ? "selected" : ""}
      onClick={handleClick}
    >
      {buttonLabel}
    </TradeDirectionListItem>
  );
}
